<template>
  <div
    v-if="visible"
    class="bg-white padding-five-all margin-top-ten gestor-centralizado-actions"
  >
    <b-container fluid class="px-0">
      <b-row>
        <b-col cols="12" class="text-center text-lg-right">
          <b-button
            class="bg-grey-btn hidden-icon mr-2 mb-2 mb-lg-0"
            :disabled="disabled || !canSave"
            @click="$emit('add-manual')"
            
          >
            {{ messages.AGREGAR_MANUAL_BUTTON }}
          </b-button>
          <b-button
            class="bg-grey-btn hidden-icon mr-2 mb-2 mb-lg-0"
            :disabled="disabled || !canSave"
            @click="$emit('save')"
          >
            {{ messages.SAVE_BUTTON }}
          </b-button>

          <b-button
            class="btn-orange hidden-icon mr-2 mb-2 mb-lg-0"
            :disabled="disabled || !canObserve"
            @click="$emit('observe')"
          >
            {{ messages.OBSERVE_BUTTON }}
          </b-button>

          <b-button
            class="bg-orange-btn hidden-icon mb-2 mb-lg-0"
            :disabled="disabled || !canGenerate"
            @click="$emit('generate')"
          >
            {{ messages.GENERATE_BUTTON }}
          </b-button>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { MESSAGES } from "@/services/gestor-centralizado/gestor-centralizado.constants";

export default {
  name: "GestorCentralizadoActionsBar",

  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    canSave: {
      type: Boolean,
      default: false,
    },
    canObserve: {
      type: Boolean,
      default: false,
    },
    canGenerate: {
      type: Boolean,
      default: false,
    },
    canAddManual: { type: Boolean, default: false },
  },

  data() {
    return {
      messages: MESSAGES,
    };
  },
};
</script>
